export default __webpack_public_path__ + "static/media/36_mobile.719d2273.jpg";